import { ProjectDto } from '../../api/ClientApi';
import { Role } from '../../api/RoleManagement';
import { RootState } from '../reducers';

export function getAllProjectsForMe(state: RootState): ProjectDto[] | null {
    const amIPA = state.loggedEmployee.readableRoles?.includes(Role.ProjectAdmin);
    const amIPM = state.loggedEmployee.readableRoles?.includes(Role.ProjectManager);
    const amIFM = state.loggedEmployee.readableRoles?.includes(Role.FinanceManager);
    const pmID = state.loggedEmployee.basicEmployee?.id;

    const allProjects = state.projects.projects;

    return amIPA || amIFM
        ? allProjects
        : amIPM && !!pmID
          ? (allProjects?.filter((p) => p.projectManagersAzObjIds?.includes(pmID)) ?? [])
          : [];
}
